import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { CalculatorResult } from '../../../models/analysis/solar-calculator-result';

@Component({
  selector: 'psc-monthly-results-wrapper',
  templateUrl: './monthly-results-wrapper.component.html',
})
export class MonthlyResultsWrapperComponent {
  @Input() solarCalculatorResult: CalculatorResult;
  selectedMonth: number;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
  ) {
  }

  monthChanged(month: number) {
    this.selectedMonth = month;
    this.changeDetectorRef.detectChanges();
  }
}
